import React from 'react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const checkMarkIcon = <FontAwesomeIcon icon={faCheckCircle} color="green" />;
const xMarkIcon = <FontAwesomeIcon icon={faTimesCircle} color="red" />;

/// Accepts a ruleset array in [message, conditionToMeet fn] format
/// Displays a checkmark if criteria are met, X otherwise
const ErrorChecklist = ({ rules, ...values }) => {
  return (
    <Form.Text>
      {rules &&
        rules.map((rule, i) => {
          const [message, conditionToMeet] = rule;
          return (
            <div key={i}>
              {!conditionToMeet(values) ? xMarkIcon : checkMarkIcon}&nbsp;{message}
            </div>
          );
        })}
    </Form.Text>
  );
};

export { ErrorChecklist };
